import React from 'react';
import Navbar from './Navbar';
import AutomationOverlay from './AutomationOverlay';
import '../styles/Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Navbar />
      <AutomationOverlay />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
